import { getStyleDeclaration } from './get-style-declaration.js';
import { styleOverride } from './style-override.js';
import { relativeBorderRadius, widgetSelector } from './helpers';

/**
 * Формирует стили для отображения виджет контейнер.
 *
 * У виджета контейнера на бэкграунде могут присутствовать:
 *  - изображение
 *  - градиент
 *  - заливка
 *  - видео (только web/mob)
 *  - микс несколько слоев
 *
 * Размеры контейнера которые отрисовываваются должны соответсвовать 1:1 размерам в админ панели для web/mob.
 *
 * При отрисовке необходимо учесть настроенный border radius.
 *
 * Внутри виджета контейнера необходимо отрисовывать виджеты:
 *  - текст
 *  - изображение
 *  - кнопка
 * допустимо неограниченное количество виджетов
 *
 * Виджеты внутри контейнера необходимо позиционировать относительно друг друга и
 * относительно контейнера аналогично как настроено в админ панели.
 * @param widgetDescription
 */
export function containerWidget(widgetDescription) {
  const { borderRadius, placements } = widgetDescription;
  const selector = widgetSelector(widgetDescription);
  const props = [
    ['border-radius', relativeBorderRadius(borderRadius, widgetDescription)],
  ];

  return [
    ...placements.map(getStyleDeclaration.positions(selector)),
    ...placements.map(getStyleDeclaration.size(selector)),
    [selector, props],
    ...styleOverride(widgetDescription),
  ];
}
